<div class="card-header mb-4">
  <div class="title-section">
    <div style="display: flex; align-items: center; gap: 1rem">
      <button mat-stroked-button class="btn-back" (click)="goBack()" appPermissionControl="P129B0001">
        <mat-icon class="m-0">arrow_back</mat-icon>
      </button>
      <h2 class="header-title">
        Promociones / Contabilidad / <span class="text-muted">{{ promocion }}</span>
      </h2>
    </div>
  </div>
  <div class="search-section">
    <div class="button-section">
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="globalFilterValue"
          (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Buscar..."
          class="p-inputtext-sm"
          appPermissionControl="P129K0001"
        />
      </span>
      <button mat-flat-button (click)="add()" class="btn-new" appPermissionControl="P129B0002">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
    </div>
  </div>
</div>
<div class="card-white">
  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    [globalFilterFields]="['let_origen', 'let_tipomov', 'iConcepto', 'desConcepto', 'iSubConcepto', 'descSub', 'sCuenta', 'sContra']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P129T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P129C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button
                  pButton
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="edit(rowData)"
                  pTooltip="Editar"
                  tooltipPosition="top"
                  appPermissionControl="P129B0003"
                ></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteM(rowData)"
                  pTooltip="Eliminar"
                  tooltipPosition="top"
                  appPermissionControl="P129B0004"
                ></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>
